import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RoleService } from 'src/app/modules/shared/services/role/role.service';
import { ModalController } from '@ionic/angular';
import { Subscription, finalize, take } from 'rxjs';
import { ToastService } from 'src/app/modules/shared/services/toast/toast.service';
import { LoadingService } from '../loading/loading.service';

@Component({
  selector: 'app-create-role-modal',
  templateUrl: './create-role-modal.component.html',
  styleUrls: ['./create-role-modal.component.scss'],
})
export class CreateRoleModalComponent {
  @Input() service: any = this.roleService;
  form: FormGroup;
  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private roleService: RoleService,
    private modalCtrl: ModalController,
  ) {
    this.form = this.fb.group({
      roleName: ['', [Validators.required]],
      roleDescription: ['', [Validators.required]],
    });
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  onSubmit() {
    if (this.form.invalid) {
      return this.toastService.showError('Reveja os campos obrigatórios.');
    }
    this.loadingService.showLoading();

    const form = this.form.value;

    const formData = {
      nome: form.roleName,
      descricao: form.roleDescription,
    };

    return this.subscriptions.push(
      this.service
        .createRole(formData)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          }),
        )
        .subscribe({
          next: (response: any) => {
            this.toastService.showSuccess(response.message);
            return this.modalCtrl.dismiss(response, 'confirm');
          },
          error: (erro: any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          },
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
